import { useNavigate } from '@tanstack/react-router';

import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { IconSearch } from '../../icons/cdl/Search';
import { useShortcutMenu } from '../hooks/useShortcutMenu';

import { CommandItem } from './CommandItem';

export const Search = () => {
    const navigate = useNavigate();
    const role = useRole();
    const { search, setOpen } = useShortcutMenu();

    const query = search.trim();

    let searchLabel = '';

    if (!query) {
        return null;
    }

    if (role.isCustomer()) {
        searchLabel = translate('shortcutMenu.searchInOrders', { query });
    }

    if (role.isSupplier()) {
        searchLabel = translate('shortcutMenu.searchInEnquiries', { query });
    }

    if (role.isSuperAdmin()) {
        searchLabel = translate('shortcutMenu.searchInOrdersAndOffers', { query });
    }

    return (
        <CommandItem
            value={`search-${query}`}
            forceMount
            onSelect={() => {
                navigate({
                    to: '/search',
                    search: { query },
                });

                setOpen(false);
            }}
            Icon={IconSearch}
        >
            {searchLabel}
        </CommandItem>
    );
};
